import bandejaSVG from '../assets/images/fabrication/bandeja.svg';
import bandejaJPG from '../assets/images/fabrication/bandeja.jpg';
import barraSVG from '../assets/images/fabrication/barra.svg';
import barraJPG from '../assets/images/fabrication/barra.jpg';
import c_ganchoSVG from '../assets/images/fabrication/c_gancho.svg';
import c_ganchoJPG from '../assets/images/fabrication/c_gancho.jpg';
import c_transpSVG from '../assets/images/fabrication/c_transp.svg';
import c_transpJPG from '../assets/images/fabrication/c_transp.jpg';
import caranguejoSVG from '../assets/images/fabrication/caranguejo.svg';
import caranguejoJPG from '../assets/images/fabrication/caranguejo.jpg';
import circularSVG from '../assets/images/fabrication/circular.svg';
import circularJPG from '../assets/images/fabrication/circular.jpg';
import estriboSVG from '../assets/images/fabrication/estribo.svg';
import estriboJPG from '../assets/images/fabrication/estribo.jpg';
import espiralSVG from '../assets/images/fabrication/espiral.svg';
import espiralJPG from '../assets/images/fabrication/espiral.jpg';
import ferro_lSVG from '../assets/images/fabrication/ferro_L.svg';
import ferro_lJPG from '../assets/images/fabrication/ferro_L.jpg';
import ferro_uSVG from '../assets/images/fabrication/ferro_U.svg';
import ferro_uJPG from '../assets/images/fabrication/ferro_U.jpg';

const pieceTypeImages = [
  {
    title: 'Bandeja',
    imgSVG: bandejaSVG,
    imgJPG: bandejaJPG
  },
  {
    title: 'Barra',
    imgSVG: barraSVG,
    imgJPG: barraJPG
  },
  {
    title: 'Caranguejo',
    imgSVG: caranguejoSVG,
    imgJPG: caranguejoJPG
  },
  {
    title: 'Circular',
    imgSVG: circularSVG,
    imgJPG: circularJPG
  },
  {
    title: 'C/ Gancho',
    imgSVG: c_ganchoSVG,
    imgJPG: c_ganchoJPG
  },
  {
    title: 'C/ Transp',
    imgSVG: c_transpSVG,
    imgJPG: c_transpJPG
  },
  {
    title: 'Espiral',
    imgSVG: espiralSVG,
    imgJPG: espiralJPG
  },
  {
    title: 'Estribo',
    imgSVG: estriboSVG,
    imgJPG: estriboJPG
  },
  {
    title: 'Ferro L',
    imgSVG: ferro_lSVG,
    imgJPG: ferro_lJPG
  },
  {
    title: 'Ferro U',
    imgSVG: ferro_uSVG,
    imgJPG: ferro_uJPG
  }
];

export const getPieceImg = (
  pieceDescription: string,
  imgExtension: 'svg' | 'jpg'
): string => {
  const pieceTypeImage = pieceTypeImages.find(
    (pti) => pti.title === pieceDescription
  );

  return pieceTypeImage
    ? imgExtension === 'svg'
      ? pieceTypeImage.imgSVG
      : imgExtension === 'jpg'
      ? pieceTypeImage.imgJPG
      : ''
    : '';
};
